<div class="complementary-product-chips-container">
  @for (filter of displayedFilters; track filter) {
    <p-chip [label]="filter.label" [removable]="filter.key !== 'all'" (onRemove)="removeFilter(filter)"></p-chip>
  }
</div>
